<template>
  <div
    v-if="totalPages > 1"
    class="d-flex align-center justify-end bb-1 br-1 bl-1 bc-very-light-grey py-2"
    data-testId="attendance-log-editor-pagination"
  >
    <span class="fs-12">{{ firstItemIndex }}-{{ lastItemIndex }} of {{ totalItemCount }}</span>

    <v-pagination
      @next="emit('update:current-page', $event)"
      @prev="emit('update:current-page', $event)"
      :length="totalPages"
      :model-value="currentPage"
      :total-visible="0"
      density="compact"
      variant="text"
    />
  </div>
</template>

<script setup>
const emit = defineEmits(['update:current-page']);

const props = defineProps({
  currentPage: {
    type: Number,
    default: 1,
  },
  pageSize: {
    type: Number,
    default: 20,
  },
  totalItemCount: {
    type: Number,
    default: 0,
  },
  totalPages: {
    type: Number,
    default: 1,
  },
});

const firstItemIndex = computed(() => {
  return (props.currentPage - 1) * props.pageSize + 1;
});

const lastItemIndex = computed(() => {
  return Math.min(props.pageSize * props.currentPage, props.totalItemCount);
});
</script>
